import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "64px",
  background: "#FCF9F7",

  [props.theme.breakpoints.down("lg")]: {
    padding: "56px 32px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  flexDirection: "column",
  alignItems: "center",
  gap: "64px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "unset",
    alignItems: "flex-start",
    gap: "40px",
    alignSelf: "stretch",
    margin: "auto",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  width: "100%",
  maxWidth: "1200px",
  justifyContent: "space-between",
  alignItems: "stretch",
  gap: "64px",

  [props.theme.breakpoints.down("lg")]: {
    maxWidth: "unset",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "40px",
    alignSelf: "stretch",
    textAlign: "left",
  },

  [props.theme.breakpoints.down("tablet")]: {
    textAlign: "left",
  },
}));

export const CardImage = styling("img")((props) => ({
  width: "100%",
  // height: "100%",
  borderRadius: "8px",
  maxHeight: "540px",
  maxWidth: "540px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
    maxWidth: "450px",
    height: "450px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "300px",
    maxWidth: "100%",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "40px",
  width: "50%",

  [props.theme.breakpoints.down("lg")]: {
    width: "100%",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextOnlyContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "24px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "40px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 400,
  lineHeight: props.type == "desc" ? "30px" : "48px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.03px" : "0.06px",

  "& i": {
    color: "#512ACC",
  },

  "& p": {
    paddingTop: "8px",
    margin: "0px",
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "20px" : "36px",
    lineHeight: props.type == "desc" ? "30px" : "43.2px",
    letterSpacing: props.type == "desc" ? "0.03px" : "0.36px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "16px" : "24px",
    lineHeight: props.type == "desc" ? "22.4px" : "28.8px",
    textAlign: props.type == "desc" ? "left" : "left",
    letterSpacing: props.type == "desc" ? "unset" : "0.036px",
  },
}));

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
    fontWeight: 700,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "220px",
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));
